// features/email-tracking/email-tracking.slice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { logOut } from '../../../redux/auth/authSlice';
import { getEmailTrackingApi } from './email-tracking.service';
import { EmailTrackingDetails } from './email-tracking.types';

export const fetchEmailTracking = createAsyncThunk(
    'emailTracking/fetch',
    async (invoiceId: number) => {
        return await getEmailTrackingApi(invoiceId);
    }
);

interface EmailTrackingState {
    details: EmailTrackingDetails | null;
    loading: boolean;
    error: string | null;
}

const initialState: EmailTrackingState = {
    details: null,
    loading: false,
    error: null,
};

const emailTrackingSlice = createSlice({
    name: 'emailTracking',
    initialState,
    reducers: {
        clearEmailTracking: (state) => {
            state.details = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmailTracking.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.details = null;
            })
            .addCase(fetchEmailTracking.fulfilled, (state, action) => {
                state.loading = false;
                state.details = action.payload;
            })
            .addCase(fetchEmailTracking.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to fetch email tracking';
            })
            // Reset when the user logs out (matches invoice.slice pattern)
            .addCase(logOut, () => initialState);
    },
});

export const { clearEmailTracking } = emailTrackingSlice.actions;
export default emailTrackingSlice.reducer;
